// extracted by mini-css-extract-plugin
export default {"ques":"FAQ_ques__3wFXZ","title":"FAQ_title__Q5vm7","FAQ":"FAQ_FAQ__u95cr","icon":"FAQ_icon__PfNnU","ans":"FAQ_ans__Pdp4V","show":"FAQ_show__8BzgE"};